<template>
  <main class="MainRouter-styles-main-block MainRouter-styles-main-block-cashier">
    <div class="ErrorCustomerCard-styles-error-customer-card">
      <div class="ErrorCustomerCard-styles-content">
        <div class="ErrorCustomerCard-styles-icon-row">
          <div class="ErrorCustomerCard-styles-icon"></div>
        </div>
        <div class="ErrorCustomerCard-styles-info-row">{{ t.payment_reseller_error_message }}</div>
        <div class="ErrorCustomerCard-styles-button-row">
          <router-link :to="{name: 'Home'}">
            <button id="error-customer-card-button" class="Button-styles-button Button-styles-primary Button-styles-confirmation Button-styles-fixed-width CommonButton-styles-common-button CommonButton-styles-confirmation CommonButton-styles-primary">
              <div class="">{{ t.go_to_homepage }}</div>
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
export default {
  name: 'errorReseller',
  data () {
    return {
      t: this.$root.t
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/transfer/errorReseller.vue